var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$store.getters.logged)?_c('gnetLogin',{on:{"login":_vm.decryptToken}}):_vm._e(),(_vm.$store.getters.logged)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }